import model from './model';
import views from './views';

export default model.views(views);
